import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/2b4e1e6f3c24db72e3a11598a883bc9d.jpg"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-green-900/90 to-green-800/75" />
      </div>
      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2
          className="text-5xl font-bold text-white mb-4"
          style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.04em' }}
        >
          READY TO ACE <span className="text-lime-400">MATH?</span>
        </h2>
        <p className="text-green-200 text-lg mb-8 max-w-lg mx-auto">
          Step onto the court, answer the question, win the point. Your math skills have never had this much action.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/level-selector"
            className="px-8 py-3.5 rounded-full bg-lime-400 text-green-900 font-bold text-base hover:bg-lime-300 cursor-pointer transition-all whitespace-nowrap"
          >
            <i className="ri-tennis-ball-fill mr-2" />
            Start a Match
          </Link>
          <Link
            to="/game-overview"
            className="px-8 py-3.5 rounded-full border-2 border-white/40 text-white font-medium text-base hover:bg-white/10 cursor-pointer transition-all whitespace-nowrap"
          >
            Game Overview
          </Link>
        </div>
      </div>
    </section>
  );
}
